/* eslint-disable react/require-default-props */
import React, { Dispatch, SetStateAction } from 'react'

import { Form, Input } from 'antd'
import { Rule } from 'antd/lib/form'

interface IProps {
  name: string
  label: string
  placa: string
  setPlaca: Dispatch<SetStateAction<string>>
  rules?: Rule[]
  disabled?: boolean
}

const InputPlaca: React.FC<IProps> = ({
  name,
  label,
  placa,
  setPlaca,
  rules,
  disabled,
}) => {
  return (
    <Form.Item name={name} label={label} rules={rules}>
      <Input
        maxLength={7}
        style={{ textTransform: 'uppercase' }}
        type="text"
        value={placa.toUpperCase()}
        disabled={disabled}
        onChange={(e) => setPlaca(e.target.value.toUpperCase())}
      />
    </Form.Item>
  )
}

export default InputPlaca
